<template>
  <v-container grid-list-lg v-if="breadcrumb && breadcrumb.length > 0" class="py-0">
    <v-layout row wrap>
      <v-flex xs12>
        <v-card flat>
          <v-card-text style="padding-left: 0px;padding-top:27px;padding-bottom:0px">
            <v-breadcrumbs
            :items="breadcrumb"
          >
            <content slot="divider">
              <span class="hidden-md-and-up subheading"><v-icon style="padding-top:0px">chevron_right</v-icon></span>
              <span class="hidden-sm-and-down headline"><v-icon style="padding-top:0px">chevron_right</v-icon></span>
            </content>
              <template slot="item" slot-scope="props">
                <router-link :to="{path: props.item.path}">
                  <h1 class="page-title page-headline title hidden-sm-and-down index-title mb-0 mt-0">
                    <span v-html="$t(props.item.key)"></span>
                  </h1>
                  <h5 class="subheading page-headline hidden-md-and-up index-title mb-0 mt-0">
                    <span v-html="$t(props.item.key)"></span>
                  </h5>
                </router-link>
              </template>
            </v-breadcrumbs>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <div class="page-border"></div>
  </v-container>
</template>

<script>
export default {
  props: {
    breadcrumb: {
      type: Array
    },
    icon: {
      type: String
    },
    color: {
      type: String
    },
    alignment: {
      type: String
    }
  }
}
</script>

<style scoped>
a, a:visited, a:active {
  color: rgba(0,0,0,.54)!important;
  text-decoration: none;
} a:hover {
  color: rgba(0,0,0,.9)!important;
  text-decoration: none;
}
.page-headline {
  font-size: 24px !important;
  font-family: "Open Sans Regular", sans-serif !important;
  font-weight: 400 !important;
  line-height: 1 !important;
  letter-spacing: 0.02em !important;
}
.page-border {
  opacity: 0.5;
  height: 1px;
  margin-bottom: 5px;
  background: rgba(105, 105, 105, 1);
  background: -moz-linear-gradient(
    left,
    rgba(105, 105, 105, 1) 0%,
    rgba(255, 255, 255, 0.77) 81%,
    rgba(255, 255, 255, 0.71) 100%
  );
  background: -webkit-gradient(
    left top,
    right top,
    color-stop(0%, rgba(105, 105, 105, 1)),
    color-stop(81%, rgba(255, 255, 255, 0.77)),
    color-stop(100%, rgba(255, 255, 255, 0.71))
  );
  background: -webkit-linear-gradient(
    left,
    rgba(105, 105, 105, 1) 0%,
    rgba(255, 255, 255, 0.77) 81%,
    rgba(255, 255, 255, 0.71) 100%
  );
  background: -o-linear-gradient(
    left,
    rgba(105, 105, 105, 1) 0%,
    rgba(255, 255, 255, 0.77) 81%,
    rgba(255, 255, 255, 0.71) 100%
  );
  background: -ms-linear-gradient(
    left,
    rgba(105, 105, 105, 1) 0%,
    rgba(255, 255, 255, 0.77) 81%,
    rgba(255, 255, 255, 0.71) 100%
  );
  background: linear-gradient(
    to right,
    rgba(105, 105, 105, 1) 0%,
    rgba(255, 255, 255, 0.77) 81%,
    rgba(255, 255, 255, 0.71) 100%
  );
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#696969', endColorstr='#ffffff', GradientType=1 );
}
.v-icon {
  padding-top: 22px;
  color: #696969;
  font-size: 30px !important;
  font-weight: 500;
}
ul {
  padding-left: 0px;
  padding-top: 0px;
}
</style>



// WEBPACK FOOTER //
// src/client/components/public/PageBreadcrumb.vue